import { useEffect } from "react";
import { Provider } from "react-redux";
import { ToastProvider } from "react-toast-notifications";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { ToastContainer } from "react-toastify";

import AppRouter from "./Route/AppRouter";
import store, { saveState } from "./redux/store";
import ApiClient from "./Route/ApiClient";

import "react-phone-number-input/style.css";
import "react-toastify/dist/ReactToastify.css";
import "./App.scss";

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			retry: false,
			staleTime: 30000,
		},
	},
});

const App = () => {
	ApiClient.setupInterceptors(store);

	useEffect(() => {
		window.addEventListener("unload", saveState);
	}, []);

	return (
		<QueryClientProvider client={queryClient}>
			<Provider store={store}>
				<ToastProvider autoDismiss autoDismissTimeout={6000}>
					<AppRouter />
					<ReactQueryDevtools />
				</ToastProvider>
				<ToastContainer />
			</Provider>
		</QueryClientProvider>
	);
};

export default App;
